module.exports = __webpack_public_path__ + "static/media/weth.b985fd9f.svg";